import axios, { AxiosRequestConfig } from 'axios';
import Vue from 'vue';

export interface IApi {
    get(url: string): Promise<any>;
    post(url: string, data: any): Promise<any>;
    put(url: string, data: any): Promise<any>;
    remove(url: string): Promise<any>;
}

export default class Api {
    constructor() {
        axios.defaults.baseURL = window.api;
    }

    public get(url: string) {
        return this.request('get', url);
    }

    public post(url: string, data: any) {
        return this.request('post', url, data);
    }

    public put(url: string, data: any) {
        return this.request('put', url, data);
    }

    public remove(url: string) {
        return this.request('delete', url);
    }

    private request(method: string, endpoint: string, data?: any | null) {
        const url = window.api + endpoint;

        const options: AxiosRequestConfig = {
            method,
            data,
            url,
        };

        return axios.request(options);
    }
}

const api = new Api();

Object.defineProperty(Vue.prototype, '$api', { value: api });
